<div mat-dialog-title class="sentryCameraDialogHeader">
  <div class="cameraDetails">
    <h2>{{ data.camera.name | uppercase }}</h2>
    <h3 *ngIf="data.camera.location">{{ data.camera.location.name }}</h3>
  </div>
  <div class="actions">
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      (click)="$event.stopPropagation()"
      class="kebabMenu"
    >
      <sn-icon>more_vert</sn-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="sendToVault(data.snapshot)">{{ 'common.addToVault' | t }}</button>
      <button mat-menu-item (click)="selectChannel(data.snapshot)">{{ 'common.shareInChat' | t }}</button>
      <button
        mat-menu-item
        *ngIf="data.camera.playbackUrls && showIsInLoop"
        (click)="setViewClip(data.item, data)"
      >
        {{ 'map.drawing.searchResults.ellipsesMenu.viewClip' | t }}
      </button>
      <button mat-menu-item (click)="viewDetectionDetails()">{{ 'map.drawing.searchResults.ellipsesMenu.viewDetectionDetails' | t }}</button>
      <button
        *ngIf="!reported || reporting"
        mat-menu-item
        [matTooltip]="'map.drawing.searchResults.ellipsesMenu.reportAsIncorrect' | t"
        (click)="incorrectSentryResult(data.item, data)"
      >
        {{ 'common.reportDetection' | t }}
      </button>
      <button mat-menu-item [matTooltip]="'common.videoPlayer.takeScreenshot' | t" (click)="clip(data.snapshot)">
        {{ 'common.screenshot' | t }}
      </button>
    </mat-menu>
  </div>
</div>
<mat-dialog-content>
  <sn-image-player
    class="sn-image-player"
    [src]="data.snapshot"
    [autoplay]="true"
    [aspectRatio]="aspectRatio"
    [refreshTime]="0"
  >
    <sn-player-footer-section alignment="end">
      <button
        mat-icon-button
        *ngIf="data.camera.playbackUrls && showIsInLoop"
        (click)="setViewClip(data.item, data)"
        [matTooltip]="'map.drawing.searchResults.ellipsesMenu.viewClip' | t"
      >
        <sn-icon>videocam</sn-icon>
      </button>
      <sn-player-fullscreen-control></sn-player-fullscreen-control>
    </sn-player-footer-section>
  </sn-image-player>
</mat-dialog-content>
<mat-dialog-actions alignment="end">
  <button mat-button color="danger" mat-dialog-close>{{ 'common.close' | t }}</button>
</mat-dialog-actions>
